import React, { Component } from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import './Modal.scss';

ReactModal.setAppElement('#root')
class Modal extends Component {
  constructor() {
    super()
    this.state = {}
  }

  closeModal = () => {
    console.log('closing..');
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    return (
      <ReactModal
        isOpen={this.props.isOpened}
        // onAfterOpen={this.afterOpenModal}
        onRequestClose={this.closeModal}
        className="popup-wrapper"
        overlayClassName="popup-overlay"
        contentLabel="Example Modal"
      >
        <div className='closebtn' onClick={this.closeModal}></div>
        <div className="popup-content">
          {this.props.children}
        </div>
      </ReactModal>
    );
  }
}

Modal.propTypes = {
  children: PropTypes.element.isRequired,
  isOpened: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
}

export default Modal;


// WEBPACK FOOTER //
// ./src/components/Modal/ModalWrapper.js